const formatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber
    .replace(/\D+/g, '')
    .replace(/1([0-9]{1,3})([0-9]{3})([0-9]{4}$)/gi, '($1) $2-$3');
};

export default formatPhoneNumber;
